import { render, staticRenderFns } from "./UtenteDetail.vue?vue&type=template&id=ef4a5940&"
import script from "./UtenteDetail.vue?vue&type=script&lang=ts&"
export * from "./UtenteDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports